export default {"src":"/_next/static/media/aboutus.85d0f7f6.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};